module.exports = require("preact/hooks");